/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PostAIConfigVariationRequest = {
  projectKey: string;
  configKey: string;
  /**
   * AI Config variation object to create
   */
  aiConfigVariationPost: components.AIConfigVariationPost;
};

/** @internal */
export const PostAIConfigVariationRequest$inboundSchema: z.ZodType<
  PostAIConfigVariationRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
  AIConfigVariationPost: components.AIConfigVariationPost$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "AIConfigVariationPost": "aiConfigVariationPost",
  });
});
/** @internal */
export type PostAIConfigVariationRequest$Outbound = {
  projectKey: string;
  configKey: string;
  AIConfigVariationPost: components.AIConfigVariationPost$Outbound;
};

/** @internal */
export const PostAIConfigVariationRequest$outboundSchema: z.ZodType<
  PostAIConfigVariationRequest$Outbound,
  z.ZodTypeDef,
  PostAIConfigVariationRequest
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
  aiConfigVariationPost: components.AIConfigVariationPost$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    aiConfigVariationPost: "AIConfigVariationPost",
  });
});

export function postAIConfigVariationRequestToJSON(
  postAIConfigVariationRequest: PostAIConfigVariationRequest,
): string {
  return JSON.stringify(
    PostAIConfigVariationRequest$outboundSchema.parse(
      postAIConfigVariationRequest,
    ),
  );
}
export function postAIConfigVariationRequestFromJSON(
  jsonString: string,
): SafeParseResult<PostAIConfigVariationRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PostAIConfigVariationRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PostAIConfigVariationRequest' from JSON`,
  );
}
